import React from "react";

interface ZodErrorsProps {
  errors: string[] | undefined;
}

const ZodErrors: React.FC<ZodErrorsProps> = ({ errors }) => {
  return errors ? (
    <div>
      {errors &&
        errors.map((error, index) => (
          <div key={index} className="text-red-600 homepage-text-sm">
            {error}
          </div>
        ))}
    </div>
  ) : null;
};

export default ZodErrors;
